import { t } from 'i18next';
import React from 'react';

import {
  CommonFlex,
  CommonText,
  FormAlert,
  InputField,
  InputLabel,
  InputWithLabelSection,
  RedStar,
} from '../../styledComponents/common';

const InputWithError = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  margin,
  width,
  addMoreCampNumber,
  type,
  required = true,
}) => {
  return (
    <InputWithLabelSection
      margin={margin ? margin : '0 0 0 0'}
      width={width}
      style={{ position: 'relative', paddingBottom: '15px' }}
    >
      <CommonFlex justifyContent="space-between">
        <InputLabel>
          {label}
          {required && <RedStar>*</RedStar>}
        </InputLabel>
        {addMoreCampNumber && (
          <CommonText
            color="#4AB37B"
            onClick={addMoreCampNumber}
            fontSize="10px"
            cursor="pointer"
          >
            + {t('add_more_camp_number')}
          </CommonText>
        )}
      </CommonFlex>
      <InputField
        type={type ? type : 'text'}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        error={error !== undefined}
      />
      {error !== undefined && (
        <FormAlert
          margin="0 0 0 5px"
          style={{
            position: 'absolute',
            bottom: '-5px',
          }}
        >
          {error}
        </FormAlert>
      )}
    </InputWithLabelSection>
  );
};

export default InputWithError;
